'use client';

import { KeyTextField, LinkField, RichTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import styles from './financeAccessTextContent.module.scss';
import { Button } from '@/components';
import { useVisible } from '@/hooks';

interface FinanceAccessTextContentProps {
  title: RichTextField;
  subtitle: KeyTextField;
  buttonText: KeyTextField;
  buttonLink: LinkField;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const FinanceAccessTextContent = ({
  buttonLink,
  buttonText,
  subtitle,
  title,
}: FinanceAccessTextContentProps) => {
  const [isVisible, id] = useVisible();
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <article className={styles.wrapper} id={id}>
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={title} components={components} />
      </div>
      <p className={`${styles.subtitle} ${isVisibleStyles}`}>{subtitle}</p>
      <div className={`${styles.button_wrapper} ${isVisibleStyles}`}>
        <Button link={buttonLink} text={buttonText} variation="primary" />
      </div>
    </article>
  );
};
